/**
 * Validates that a redirect target is a safe, relative path.
 * Prevents open redirect attacks by rejecting absolute URLs
 * and protocol-relative URLs.
 * Also prevents recursive redirect loops by rejecting paths that
 * resolve to the login page (e.g. /login, /login?redirect=..., /login/).
 * Also rejects paths longer than 2048 characters to guard against URI Too Long errors.
 *
 * @param redirect - The redirect value to validate (accepts unknown for defensive use)
 * @returns The validated redirect URL, or '/' if the value is unsafe or not a string
 */

const MAX_REDIRECT_LENGTH = 2048;

export function getSafeRedirectUrl(redirect: unknown): string {
  if (typeof redirect !== 'string' || !redirect) return '/';
  if (redirect.length > MAX_REDIRECT_LENGTH) return '/';
  if (!redirect.startsWith('/')) return '/';
  if (redirect.startsWith('//')) return '/';

  // Prevent recursive redirects to the login page
  const pathname = redirect.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  if (pathname === '/login') return '/';

  return redirect;
}
